import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";

const UpdateAmenity = () => {
  const [amenityName, setAmenityName] = useState("");
  const amenityId = localStorage.getItem("selectedAmenityId");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the amenity details using the amenityId
    if (amenityId && token) {
      axios
        .get(
          `${StandardURL}/iNyumba/amenities/fetch/${amenityId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setAmenityName(response.data.amenity_name);
        })
        .catch((error) => {
          console.error("Error fetching amenity details:", error);
        });
    }
  }, [amenityId, token]);

  const handleUpdateAmenity = () => {
    if (!amenityId || !token || !amenityName) {
      console.error("Amenity ID, token, or amenity name not found.");
      return;
    }

    const updatedAmenityData = {
      amenity_name: amenityName,
    };

    axios
      .patch(
        `${StandardURL}/iNyumba/amenities/update/${amenityId}`,
        updatedAmenityData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        navigate(-1);
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error updating amenity:", error);
      });
  };

  const handleDeleteAmenity = () => {
    if (!amenityId || !token) {
      console.error("Amenity ID or token not found.");
      return;
    }

    axios
      .delete(
        `${StandardURL}/iNyumba/amenities/delete/${amenityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        navigate(-1);
        // Optionally, redirect to another page or perform any additional actions
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error deleting amenity:", error);
      });
  };

  return (
  <RoleGuard>
    <AuthGuard>
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 sm:p-6 lg:p-8"> {/* Added min-height, flex centering, subtle background */}
        <div className="bg-white shadow-xl rounded-xl p-6 sm:p-8 w-full max-w-lg border border-gray-200"> {/* Enhanced card styling */}
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6 text-center"> {/* Larger, bolder, centered title */}
            Update Amenity <span role="img" aria-label="hammer and wrench">🛠️</span>
          </h1>

          <div className="mb-6">
  <label htmlFor="amenityName" className="block text-base font-semibold text-gray-700 mb-2">
    Amenity Name:
  </label>
  <input
    type="text"
    id="amenityName"
    className="w-full border border-gray-300 rounded-lg py-3 px-4 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-200"
    value={amenityName}
    onChange={(e) => setAmenityName(e.target.value)}
    placeholder="e.g., Swimming Pool, Gym, Parking"
  />
</div>

          <div className="flex flex-col sm:flex-row justify-end gap-3 mt-8">
            <button
              onClick={handleUpdateAmenity}
              className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Update Amenity
            </button>
            <button
              onClick={handleDeleteAmenity}
              className="w-full sm:w-auto bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              Delete Amenity
            </button>
          </div>
        </div>
      </div>
    </AuthGuard>
  </RoleGuard>
);
};

export default UpdateAmenity;
